import Vue from 'vue'
import Vuex from 'vuex'
import appWide from './modules/appWide'
import chats from './modules/chat'
import events from './modules/event'
import visuals from './modules/visuals'
import devices from './modules/devices'
import zoneMap from './modules/zoneMap'
import zones from './modules/zones'
import sounds from './modules/sounds'
import images from './modules/images'
import dayScheduler from './modules/dayScheduler'
import defaultScheduler from './modules/defaultScheduler'
import calendarScheduler from './modules/calendarScheduler'
import adminAudit from './modules/Administration/audit'
import adminIntercom from './modules/Administration/intercom'
import adminG2Secure from './modules/Administration/g2secure'
import adminG2IPSpeaker from './modules/Administration/g2ipspeaker'
import adminZoneMap from './modules/Administration/adminZoneMap'
import playlist from './modules/playlists'
import adminLog from './modules/Administration/log'
import adminDashboard from './modules/Administration/dashboard'
import adminFileImport from './modules/Administration/fileImport'
import adminFileExport from './modules/Administration/fileExport'
import adminMachine from './modules/Administration/machine'
import adminServerObject from './modules/Administration/serverObject'
import adminBackupAndRestore from './modules/Administration/backupAndRestore'
import adminUsers from './modules/Administration/users'
import adminPhoenixSettings from './modules/Administration/phoenixSettings'
import adminSites from './modules/Administration/site'
import adminContacts from './modules/Administration/contacts'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    appWide,
    adminZoneMap,
    adminLog,
    adminAudit,
    dayScheduler,
    defaultScheduler,
    calendarScheduler,
    devices,
    zoneMap,
    zones,
    sounds,
    images,
    adminIntercom,
    adminG2Secure,
    adminG2IPSpeaker,
    playlist,
    adminDashboard,
    adminFileExport,
    adminFileImport,
    adminMachine,
    adminServerObject,
    adminBackupAndRestore,
    adminUsers,
    chats,
    adminPhoenixSettings,
    adminSites,
    adminContacts,
    visuals,
    events
  }
})
